// Regular expressions
var harmfulProtocols = /^([^\w]*)(javascript|data|vbscript)/im;
var encodedChars = /&#(\w+)(^\w|;)?/g;
var newlineTabChars = /&(newline|tab);/gi;
var unwantedUnicodeChars = /[\u0000-\u001F\u007F-\u009F\u2000-\u200D\uFEFF]/gim;
var colonChars = /^.+(:|&colon;)/gim;

export const sanitizeUrl = (inputUrl) => {
    // Initial characters for relative URLs
    var relativePathChars = [".", "/"];

    // Replace encoded characters with actual characters
    var replacedUrl,
        cleanedUrl =
            ((replacedUrl = inputUrl || ""),
            replacedUrl.replace(encodedChars, function (t, n) {
                return String.fromCharCode(n);
            }));

    // Remove newline, tab and unwanted unicode characters
    cleanedUrl = cleanedUrl
        .replace(newlineTabChars, "")
        .replace(unwantedUnicodeChars, "")
        .trim();

    // Return about:blank if there's no URL
    if (!cleanedUrl) return "about:blank";

    // If the URL starts with a relative path, return the URL
    if (relativePathChars.indexOf(cleanedUrl[0]) > -1) return cleanedUrl;

    // Check if the URL has a colon or &colon;
    var matchedColon = cleanedUrl.match(colonChars);

    // Return the URL if there's no colon or &colon;
    if (!matchedColon) return cleanedUrl;

    // Get the matched string
    var matchedString = matchedColon[0];

    // If the matched string starts with javascript, data or vbscript, return about:blank
    return harmfulProtocols.test(matchedString) ? "about:blank" : cleanedUrl;
};
